import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Hero.css";

interface CountdownTime {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const Hero: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<CountdownTime>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = (): CountdownTime => {
      // Wedding ceremony: November 29, 2025 at 3:00 PM CT
      const weddingDate = new Date('2025-11-29T15:00:00-06:00'); // CT is UTC-6 (or UTC-5 during DST)
      const now = new Date();
      const difference = weddingDate.getTime() - now.getTime();

      if (difference > 0) {
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }

      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Calculate initial time
    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, []);

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <img src={process.env.PUBLIC_URL + "/venue.PNG"} alt="Venue" className="hero-venue-img" />
        <div className="hero-text">
          <h1 className="couple-names">Michael & Ashlynn</h1>
          <h2 className="wedding-date">November 29, 2025 • 3:00 PM CT</h2>
          
          <div className="countdown-container">
            <div className="countdown-timer">
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.days}</span>
                <span className="countdown-label">Days</span>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.hours}</span>
                <span className="countdown-label">Hours</span>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.minutes}</span>
                <span className="countdown-label">Minutes</span>
              </div>
              <div className="countdown-separator">:</div>
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.seconds}</span>
                <span className="countdown-label">Seconds</span>
              </div>
            </div>
          </div>

          <p className="wedding-tagline">Join us as we celebrate our love</p>
          <div className="hero-buttons">
            <Link to="/rsvp" className="btn btn-primary">
              RSVP Now
            </Link>
            <Link to="/details" className="btn btn-secondary">
              View Itinerary
            </Link>
          </div>
        </div>
      </div>
      <div className="hero-overlay"></div>
    </section>
  );
};

export default Hero;
